import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
    },
    headerContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    title: {
      flex: '1 1 0',
    },
    headerActions: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'nowrap',

      '& > *:not(:last-child)': {
        marginRight: theme.spacing(1),
      },
    },
    select: {
      color: theme.palette.primary.main,
    },
    text: {
      textTransform: 'uppercase',
      fontWeight: 500,
      fontSize: '0.875rem',
    },
    content: {
      padding: '20px 24px !important',
    },
  };
};
